module.exports = __webpack_public_path__ + "img/desk3.50768363.png";